import React, { useContext, useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import DialogAcerBrag from '../../components/UI/DialogAcerBrag';
import LimitedBackdrop from '../../components/UI/LimitedBackdrop';
import { AppContext } from '../../contexts/AppContext';
import purchaseOrdersApi from '../../services/purchaseOrdersApi';
import PurchaseOrderDetailGrid from './PurchaseOrderDetailGrid';

const PurchaseOrderDetailModal = ({ open, setOpen, cuit, purchaseOrderNumber }) => {
  const { showError } = useContext(AppContext);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [detail, setDetail] = useState([]);

  const resetFields = () => {
    setDetail([]);
  };

  useEffect(() => {
    if (open) {
      setOpenBackDrop(true);
      purchaseOrdersApi
        .getDetail(purchaseOrderNumber, { Cuit: cuit })
        .then(res => {
          setDetail(res.data);
          setOpenBackDrop(false);
        })
        .catch(error => {
          setOpen(false);
          showError('Error al obtener el detalle');
        });
    } else {
      setTimeout(() => {
        resetFields();
      }, 500);
    }
  }, [open]);

  return (
    <DialogAcerBrag
      open={open}
      setOpen={setOpen}
      title={detail[0] ? `Nro. Pedido de Compra ${detail[0].purchaseOrderCode}` : 'Detalle'}
      purchaseOrderDate={detail[0]?.purchaseOrderDate}>
      <LimitedBackdrop open={openBackDrop}>
        <CircularProgress color="primary" />
      </LimitedBackdrop>
      <PurchaseOrderDetailGrid data={detail} />
    </DialogAcerBrag>
  );
};
export default PurchaseOrderDetailModal;
